import { render, staticRenderFns } from "./PersonalitySplitCard.vue?vue&type=template&id=2bd1538a&"
import script from "./PersonalitySplitCard.vue?vue&type=script&lang=js&"
export * from "./PersonalitySplitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports